import { useMemo } from 'react';

import {
  ActivityBuilderDrawerWrapper,
  ActivityBuilderDrawerContent,
  ActivityBuilderDrawerHeader,
} from 'approot/activity-builder/activity-builder-drawer';
import {
  SettingsGroup,
  SettingsLabel,
} from 'approot/activity-builder/settings/settings.style';
import {
  InquisitiveActivitiesContentType,
  InquisitiveLanguageCodes,
} from 'global/graphql/scalars.type';
import { useStudentClassSettings } from 'approot/students/student-class-settings.hooks';
import { isStudentAuthenticated } from 'approot/students/logic/is-student-authenticated';
import { Heading16, PStyled } from 'approot/shared/styles/typography.style';
import ActivityPresentLanguage from 'approot/activity-builder/present/activity-present-language';
import Bouncer from 'approot/shared/bouncer/bouncer';
import LayoutCenteredMessage from 'approot/shared/layout/layout-centered-message';

type Props = {
  version: string;
  contentType: InquisitiveActivitiesContentType;
  lang: InquisitiveLanguageCodes;
  availableTranslations: InquisitiveLanguageCodes[];
  onClose: () => void;
};

const StudentPresentMenuTranslate = ({
  version,
  contentType,
  lang,
  availableTranslations,
  onClose,
}: Props) => {
  const isLoggedIn = useMemo(() => isStudentAuthenticated(), []);

  const { translationEnabled, loading: loadingSettings } =
    useStudentClassSettings();

  return (
    <ActivityBuilderDrawerWrapper>
      <ActivityBuilderDrawerHeader title="Translate" onClose={onClose} />
      <ActivityBuilderDrawerContent>
        {loadingSettings ? (
          <Bouncer />
        ) : isLoggedIn && translationEnabled ? (
          <SettingsGroup>
            <SettingsLabel>Language</SettingsLabel>
            <ActivityPresentLanguage
              isStudent
              language={lang}
              version={version}
              contentType={contentType}
              availableTranslations={availableTranslations}
            />
          </SettingsGroup>
        ) : (
          <LayoutCenteredMessage>
            <Heading16 as="h2" textAlignCenter>
              Oops! You can’t change the language right now.
            </Heading16>
            <PStyled textAlignCenter>
              Your teacher needs to switch it on. Ask them for help if you need
              it!
            </PStyled>
          </LayoutCenteredMessage>
        )}
      </ActivityBuilderDrawerContent>
    </ActivityBuilderDrawerWrapper>
  );
};

export default StudentPresentMenuTranslate;
